const GOOGLE_EMAIL_SCOPE = 'email';
const GOOGLE_PROFILE_SCOPE = 'profile';
const GOOGLE_AUTH_SCOPES = [
  GOOGLE_EMAIL_SCOPE,
  GOOGLE_PROFILE_SCOPE,
  YOUTUBE_SCOPE,
  YOUTUBE_ANALYTICS_SCOPE,
];
const GOOGLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth';

class YouTubeSettingsController {
  constructor(YouTubeUser, toaster, $state, $timeout) {
    'ngInject';
    this.YouTubeUser = YouTubeUser;
    this.toaster = toaster;
    this.$state = $state;

    this.youtubeUsers = [];

    // If this page was loaded with `code`
    const code = $state.params.code,
      error = $state.params.error;
    if (code) {
      this.addCode(code);
    } else if (error) {
      let error_message = `Unable to link the requested YouTube account (YouTube said: "${error}"). Please try again.`;
      if (error == 'access_denied') {
        error_message =
          'Unable to link the requested YouTube account, as access was denied. Please try again.';
      }
      $timeout(() => toaster.pop('warning', error_message), 0);
    } else if ($state.params.link) {
      this.linkAccount();
    } else {
      $state.go('settings.integrations');
    }
  }

  addCode(code) {
    const { YouTubeUser, toaster, $state } = this;

    // Ask the API to get the token for this code and redirect_uri
    const user = new YouTubeUser({ code: code, redirect_uri: YOUTUBE_OAUTH_REDIRECT });
    const promise = user
      .$save()
      .then((u) => {
        toaster.pop('success', 'Successfully linked YouTube account.');
        $state.go('settings.integrations', { integration_id: u.id });
      })
      .catch((err) => {
        console.error(err);
        if (
          err.status == 422 &&
          err.data &&
          err.data.invalid_fields &&
          err.data.invalid_fields.refresh_token
        ) {
          toaster.pop(
            'warning',
            'Unable to link the requested YouTube account. Is it already linked?'
          );
        } else {
          toaster.pop(
            'warning',
            'Unable to link the requested YouTube account. Please reload this page and try again.'
          );
        }
        $state.go('settings.integrations');
      });
    this.loadingPromises = [promise];
  }

  linkAccount() {
    const authParams = {
      client_id: YOUTUBE_CLIENT_ID,
      redirect_uri: YOUTUBE_OAUTH_REDIRECT,
      scope: GOOGLE_AUTH_SCOPES.join(' '),
      response_type: 'code',
      access_type: 'offline',
      prompt: 'consent',
    };
    const queryStr = Object.keys(authParams)
      .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(authParams[k])}`)
      .join('&');
    window.location.replace(`${GOOGLE_AUTH_URL}?${queryStr}`);
  }
}

export default YouTubeSettingsController;



// WEBPACK FOOTER //
// ./app/pages/settings/youtube.js